module.exports = __webpack_public_path__ + "img/Soroka_Hospital.0e2cd4aa.svg";